import { Masthead } from "../components/Masthead";
import { idx } from "../store";

export function About() {
  const I = idx.value!;
  document.title = "O projektu · Slušam";
  return (
    <>
      <Masthead compact />
      <div class="page" style="max-width:760px">
        <h1 style="font:400 44px/1 var(--display);margin:.2rem 0 1rem">O projektu</h1>
        <p>Slušam je nezvaničan katalog predmeta i planer rasporeda za fakultete i akademije Univerziteta u Sarajevu. Nije povezan s Univerzitetom ni s fakultetima.</p>
        <p>Trenutno sadrži {I.core.courses.length} predmeta, {I.core.sessions.length} termina i {I.core.people.length} nastavnika. Sve je preuzeto s javnih stranica fakulteta: rasporedi nastave, nastavni planovi i programi i silabusi. Dio silabusa je prepisan OCR-om sa skeniranih dokumenata. Podaci mogu imati greške ili kasniti za izmjenama, pa termine uvijek provjerite kod nastavnika ili studentske službe.</p>
        <p>Email adrese su sa službenih stranica. Adrese označene kao „pretpostavljeno“ su izvedene iz obrasca adresa fakulteta i nisu potvrđene.</p>
        <p>Vaši rasporedi se čuvaju samo u vašem pregledniku. Ako podijelite ili objavite raspored, njegova kopija se čuva na serveru da bi link radio. Nema kolačića za praćenje.</p>
        <p>Grešku možete prijaviti dugmetom „Prijavi grešku“ na stranici predmeta. Za uklanjanje podataka ili pitanja pišite na <a href="mailto:me@qoobes.dev">me@qoobes.dev</a>.</p>
      </div>
    </>
  );
}
